<template>
  <div class="container">
    <div class="commodity">
      <div class="commodity-img">
        <div class="comimg">
          <img
            :src="goodInfo.goodsImgUrl"
            alt=""
            width="100%"
          />
        </div>
        <div class="commodity-content">
          <span class="title">{{ goodInfo.goodsName }}</span>
<!--          <span class="text">黑色和米白色桑蚕丝斜纹</span>-->
          <span class="count">x{{ goodInfo.goodsNum }}</span>
        </div>
      </div>
    </div>
    <div class="Payment">
      <div class="payspan">
        <!-- <span class="refund">退款金额：</span> -->
        <!-- <span class="payagree">¥{{ goodInfo.actualPayTotalAmount }}</span> -->
        <van-field
          class="payagree"
          v-model="goodInfo.actualPayTotalAmount"
          label="退款金额："
          required
          input-align="right"
          type="number"
        />
      </div>
      <span class="modify"
        >可修改，最多￥{{ goodInfo.actualPayTotalAmount }}（含运费￥0.00）</span
      >
    </div>
    <div class="reason">
      <van-field
        class="reason-vanfield"
        readonly
        clickable
        label="退款原因："
        :right-icon="icons"
        @click="showPicker = true"
        v-model="rdioName"
      />
      <div class="reasonvanpop">
        <van-popup
          class="reason-vanpop"
          v-model="showPicker"
          round
          position="bottom"
        >
          <div class="restitle">退款原因</div>
          <div>
            <div class="rdio_box">
              <label
                class="rdiolabel"
                v-for="(item, index) in items"
                :key="index"
              >
                <span>{{ item.label }}</span>
                <input
                  type="radio"
                  name="radio"
                  :value="item.id"
                  v-model="rdioValue"
                  @click.stop="radiochoose(item)"
                />
              </label>
            </div>
            <div class="btn" @click="showPicker = false">确认提交</div>
          </div>
        </van-popup>
      </div>
    </div>
    <div class="remarks">
      <div class="remarks-title">
        <span class="remarks-bz">备注说明：</span>
        <span class="remarks-qs">请说明</span>
      </div>
      <textarea class="remarks-input" type="text" v-model="applyDetailReason" />
    </div>
    <div class="remark">
      <div class="remark-title">
        <span class="remark-bz">上传凭证：</span>
        <span class="remark-qs">（最多上传3张）</span>
      </div>
      <van-uploader
        class="vanuploader"
        v-model="fileList"
        multiple
        :max-count="3"
        :upload-icon="icon"
        :after-read="afterRead"
      />
    </div>
    <div class="btn" @click="submit()">确认提交</div>
  </div>
</template>

<script>
import { getOrderDetail,apply } from "@/api/api";
import axios from "axios";
export default {
  data() {
    return {
      value: "",
      fileList: [],
      radio: "0",
      showPicker: false,
      icon: require("../../../assets/icon/plus.png"),
      icons: require("../../../assets/icon/icon_more.png"),
      rdioValue: "",
      rdioName: "",
      applyReason:"",
      items: [
        {
          label: "订单信息拍错（规格/尺码/颜色等）",
          id: 1,
        },
        {
          label: "不想要了",
          id: 2,
        },
        {
          label: "地址/电话信息填写错误",
          id: 3,
        },
        {
          label: "没用/少用优惠",
          id: 4,
        },
        {
          label: "缺货",
          id: 5,
        },
      ],
      orderNo: this.$route.query.orderNo, // 订单号
      goodsId: this.$route.query.goodsId, // 商品id
      goodInfo: {}, // 商品信息
      afterType: this.$route.query.afterType, // 售后类型
      applyDetailReason:'',//备注
    };
  },
  methods: {
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    radiochoose: function (item) {
      this.rdioName = item.label;
      this.applyReason = item.id;
    },
    // 获取订单详情
    async getData() {
      const params = {
        orderNo: this.orderNo,
      };
      const res = await getOrderDetail(params);
      if (res.code == "0000" && res.data) {
        // 通过子订单号码获取到对应的子订单信息
        // 再通过商品ID获取到对应的商品信息
        if (res.data.orderList && res.data.orderList.length > 0) {
          const list = res.data.orderList;
          list.forEach((item) => {
            if (item.orderNo == this.orderNo) {
              item.goodsInfoList.forEach((itm) => {
                if (this.goodsId == itm.goodsId) {
                  this.goodInfo = itm;
                }
              });
            }
          });
        }
      } else {
        this.$toast(res.msg);
      }
    },
    // 提交申请
    async submit() {
      let params = {};
      if(this.goodInfo.actualPayTotalAmount === "" || this.goodInfo.actualPayTotalAmount < 0){
          return this.$toast('请输入退款金额~');
      }
      if(this.rdioValue === '') {
        return this.$toast('请选择退款原因~');
      }

      params = {
        afterSaleType: this.afterType,
        applyReason: this.applyReason,
        note: this.note || '',
        orderNo: this.orderNo,
        goodsId: this.goodInfo.goodsId,
        goodsNum: this.goodInfo.goodsNum,
        applyDetailReason:this.applyDetailReason
      };
      const res = await apply(params);
      if(res.code === '0000') {
        this.$toast('商家正在快马加鞭的处理，请耐心等待！');
        setTimeout(() => {
          this.$router.push({
            path: '/orders/afterservice'
          })
        },500)
      }else {
        this.$toast("提交失败，请再次尝试~");
      }
    },
    //上传图片
    afterRead(file) {
      let url = this.config.upload + "/api/upload";
      let params = new FormData();
      params.append("file", file.file);
      let config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      };
      axios.post(url, params, config).then(res => {
        this.fileList.push(res.data.data.imgUrl);
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.container {
  .commodity {
    background-color: #fff;
    padding: 0 20px;
    margin-bottom: 20px;

    .commodity-img {
      border-top: 1px solid #999999;
      padding: 15px 20px 20px 20px;
      display: flex;

      span {
        display: block;
      }

      .commodity-content {
        padding-left: 20px;

        .title {
          font-size: 28px;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
          padding-bottom: 10px;
        }

        .text {
          font-size: 26px;
          font-weight: 500;
          color: #999999;
          line-height: 37px;
          padding-bottom: 33px;
        }

        .count {
          font-size: 28px;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
          text-align: right;
        }
      }

      .comimg {
        width: 180px;
        height: 180px;

        img {
          border-radius: 8px;
        }
      }
    }
  }

  .Payment {
    padding: 0 40px;
    background-color: #fff;
    box-shadow: 0px 0px 2px 0px rgba(51, 51, 51, 0.15);
    align-items: center;
    margin-bottom: 21px;
    .modify {
      display: block;
      font-size: 26px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #999999;
      line-height: 37px;
      padding-bottom: 36px;
    }
    .payspan {
      display: flex;
      justify-content: space-between;
      padding-top: 34px;
      padding-bottom: 2px;
      span {
        display: block;
      }

      .refund {
        font-size: 28px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
      }

      .payagree {
        font-size: 28px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: $theme-color-main;
        line-height: 40px;
      }
    }

    .payimg {
      width: 32px;
      height: 32px;
    }
  }
  .reason {
    background: #ffffff;
    box-shadow: 0px 0px 2px 0px rgba(51, 51, 51, 0.15);
    margin-bottom: 20px;
    .reason-vanfield {
      padding: 30px 40px;
    }
    .reason-vanpop {
      height: 812px;
      border-radius: 0;
      .restitle {
        padding-top: 30px;
        padding-bottom: 30px;
        text-align: center;
        font-size: 36px;
        font-weight: 400;
        color: rgba(55, 64, 77, 0.7);
        letter-spacing: 0px;
      }

      .radio {
        display: none;
        display: inline-block;
        width: 25px;
        height: 25px;
        vertical-align: middle;
        cursor: pointer;
        background-image: url(../../../assets/icon/Auditing.png);
        background-repeat: no-repeat;
        //background-position: 0 0;
        background-size: 100% 100%;
      }
    }
  }
  .remarks {
    padding: 0 40px;
    background-color: #fff;
    .remarks-title {
      display: flex;
      padding: 30px 0 20px 0;
      .remarks-bz {
        font-size: 28px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
      }
      .remarks-qs {
        font-size: 28px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #999999;
        line-height: 40px;
      }
    }
    .remarks-input {
      width: 670px;
      height: 200px;
      background: #f9f9f9;
      border: 1px solid #979797;
      margin-top: 1px;
      resize: none;
    }
  }
  .remark {
    padding: 0 40px;
    background-color: #fff;
    .remark-title {
      display: flex;
      padding: 20px 0 30px 0;
      .remark-bz {
        font-size: 28px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
      }
      .remark-qs {
        font-size: 28px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #999999;
        line-height: 40px;
      }
    }
    .vanuploader {
      padding-bottom: 50px;
    }
  }
  .btn {
    width: 580px;
    height: 88px;
    margin: 0 auto;
    line-height: 88px;
    background: #1e53a4;
    border-radius: 44px;
    font-size: 36px;
    font-weight: 500;
    text-align: center;
    color: #ffffff;
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 30px;
  }
}
</style>
<style scoped>
.rdio_box {
  background-color: #ffffff;
  height: 30px;
}
.rdiolabel {
  display: flex;
  justify-content: space-between;
  padding: 30px 0px 30px 0px;
  margin-left: 30px;
  margin-right: 30px;
  border-bottom: 1px solid #f0f0f0;
}
.rdiolabel span {
  font-size: 32px;
  font-family: .PingFangSC, .PingFangSC-Regular;
  font-weight: 400;
  color: #37404d;
  line-height: 33px;
  letter-spacing: 0px;
}
/*设置radio的样式*/
.rdio_box input[type="radio"] {
  background-size: 36px 36px;
  width: 36px;
  height: 36px;
  border: #f0f0f0;
  vertical-align: middle;
  outline: none; /*去掉自带的边框*/
}
.rdio_box input[type="radio"]:checked {
  -webkit-appearance: none;
  background: url(../../../assets/icon/icon_selet.png) no-repeat;
  background-size: 36px 36px;
  width: 36px;
  height: 36px;
  vertical-align: middle;
  outline: none;
}
</style>
